import { Component } from '@angular/core';
import { buildInfo } from 'env/build-info';

import { SvgLoaderComponent } from 'app/components/ui-kit/images/svg-loader/svg-loader.component';

import { AuthService } from 'app/services/auth.service';
import { Router } from '@angular/router';
import { DeviceService } from 'app/services/device.service';
import { CommonModule } from '@angular/common';
import { NavUserWidgetComponent } from '../nav-user-widget/nav-user-widget.component';
import { NavNotificationWidgetComponent } from '../nav-notification-widget/nav-notification-widget.component';
import { AppStateService } from 'app/services/app-state.service';

@Component({
  selector: 'app-nav',
  standalone: true,
  imports: [SvgLoaderComponent, CommonModule, NavNotificationWidgetComponent, NavUserWidgetComponent],
  templateUrl: './nav.component.html',
  styleUrl: './nav.component.scss'
})
export class NavComponent {
  buildData: any = buildInfo;
  isNavIOS: boolean = false;
  currentTheme: string = 'dark-theme';
  isMobile: boolean;

  private bodyClassObserver: MutationObserver;

  public navLinks = [
    { url: 'agent', name: 'Agent' },
    { url: 'watchers', name: 'Watching' },
    { url: 'connections', name: 'Flights' }
  ]

  constructor(private authService: AuthService, private router: Router, private deviceService: DeviceService, public appState: AppStateService) {
  }

  ngOnInit() {
    this.observeBodyClassChanges();
    const isAppleDevice = this.deviceService.isAppleDevice() || false;
    const deviceType = this.deviceService.getDeviceType() || 'desktop';
    this.isMobile = this.deviceService.getDeviceType() === 'mobile';
    if (isAppleDevice && deviceType === 'mobile') {
      this.isNavIOS = true;
    }
  }

  async onClickLogo() {
    const isAuthed = await this.authService.isAuthenticated();
    if (isAuthed) {
      this.router.navigate(['/agent'])
    } else {
      this.router.navigate(['/landing'])
    }
  }

  onClickBackButton() {
    this.appState.agent.mode.set('agent');
    const backButtonState = this.appState.navigation.backButtonState();
    if (backButtonState) {
      this.appState.navigation.backButtonState.set(null);
      this.router.navigate([backButtonState.value]);
    }
  }

  private observeBodyClassChanges(): void {
    const body = document.body;

    const updateTheme = () => {
      this.currentTheme = body.classList.contains('dark-theme') ? 'dark-theme' : 'light-theme';
    };

    this.bodyClassObserver = new MutationObserver(updateTheme);

    this.bodyClassObserver.observe(body, {
      attributes: true,
      attributeFilter: ['class'],
    });

    updateTheme();
  }

  getLogoSize() {
    const deviceType = this.deviceService.getDeviceType();
    switch (deviceType) {
      case 'desktop':
        return '22px';
      case 'tablet':
        return '22px';
      case 'mobile':
        return '22px';
      default:
        return '22px';
    }
  }

  onClickNavLink(url) {
    this.router.navigate([url]);
  }

  checkLinkActive(linkObj) {
    return this.appState.navigation.currentURL().includes(linkObj.url);
  }

  ngOnDestroy() {
    if (this.bodyClassObserver) {
      this.bodyClassObserver.disconnect();
    }
  }

}
